import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { finalize, switchMap } from 'rxjs/operators';

import { Loader } from '../helpers/loader';
import { ParentEvents } from '../../utils/parent-events.service';

@Injectable()
export class MyHttpClient {
    constructor(private http: HttpClient, private loader: Loader, private parentEvents: ParentEvents) {}

    get(url: string): Observable<any> {
        return of(this.loader.addLoader()).pipe(
            switchMap(() =>
                this.http.get(url).pipe(
                    finalize(() => {
                        this.loader.removeLoader();
                    })
                )
            )
        );
    }

    post(url: string, body: any, options?: object): Observable<any> {
        return of(this.loader.addLoader()).pipe(
            switchMap(() =>
                this.http.post(url, body, options).pipe(
                    finalize(() => {
                        this.parentEvents.reset();
                        this.loader.removeLoader();
                    })
                )
            )
        );
    }
}
